import React from 'react'

const RowContainer = () => {
  return (
    <div className=''></div>
  )
}

export default RowContainer